import { ResourceProps } from "react-admin";
import Icon from "@mui/icons-material/NightShelter";
import { Resource } from "../../enums";
import ListScreen from "./list";
import { EditScreen } from "./edit";

const developWithUsPages: ResourceProps = {
  name: Resource.DEVELOP_WITH_US_PAGES,
  icon: Icon,
  list: ListScreen,
  edit: EditScreen,
  options: {
    label: "Develop w/ Us",
  },
};

export default developWithUsPages;
